var app = angular.module("leonardo");

var FieldEditDialog = function($scope, $rootScope, FieldService, FieldSubgroupService, FormErrorsService) {

  $scope.isEdit = !isNull($scope.ngDialogData.field);
  $scope.field = angular.copy($scope.ngDialogData.field);

  $scope.subgroup = {id:$scope.ngDialogData.subgroup};
  $scope.fieldSubgroupService = FieldSubgroupService;

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();
    if ($scope.isEdit) {
      $scope.field.patch(data).then(function () {
        $rootScope.$broadcast('field:changed');
        $scope.closeThisDialog();
      });
    }
    else {
      data.key = data.name.toLowerCase().replace(/[^a-zA-Z0-9]+/g, "-");
      FieldService.post(data).then(function (result) {
        FieldService.updateCollection(result);
        $rootScope.$broadcast('field:changed');
        $scope.closeThisDialog();
      });
    }
  };

  $scope.getData = function() {
    var field_data = $scope.field.data ? $scope.field.data : {};
    if ('options' in field_data) {
      field_data['options'] = angular.isArray(field_data['options']) ? field_data['options'] : field_data['options'].split(',');
    }
    return {
      name: $scope.field.name,
      weight: $scope.field.weight,
      type: $scope.field.type,
      data: field_data,
      subgroup: $scope.subgroup.id
    };
  };
};

app.controller('FieldEditDialog', ['$scope', '$rootScope', 'FieldService', 'FieldSubgroupService', 'FormErrorsService',
  FieldEditDialog]);
